import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer, createMigrate } from 'redux-persist'
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import storage from 'redux-persist/lib/storage/session'
import { IS_PROD } from '@constants'
import alert from './alert'
import app from './app'
import checkout from './checkout'
import events from './events'
import loader from './loader'
import map from './map'
import plans from './plans'
import signup from './signup'
import { PERSIST_SLICE_KEYS } from './persistSlices'
import googleAds from './googleAds'

const migrations = {
  0: (state: any) => ({
    ...state,
  })
};

const rootReducer = combineReducers({
  alert,
  app,
  checkout,
  map,
  plans,
  signup,
  events,
  loader,
  googleAds,
})

export type RootState = ReturnType<typeof rootReducer>

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [...PERSIST_SLICE_KEYS],
  version: 0,
  migrate: createMigrate(migrations, { debug: false })
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: !IS_PROD,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch

// TODO: replace useDispatch and useSelector in project with useAppDispatch and useAppSelector
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
